import React from 'react';
/* eslint-disable @typescript-eslint/no-empty-function */
export const Context = React.createContext({
  omniUrlArgs: '',
  trackTemplateEvent: (eventWithValToTrack: string): void => {},
  selectedKnowMoreDetailsForMobile: null,
  setSelectedKnowMoreDetailsForMobile: (knowMoreDetails): void => {}
});

type Props = {
  omniUrlArgs: string;
  trackTemplateEvent: (eventWithValToTrack: string) => void;
  selectedKnowMoreDetailsForMobile?: any;
  setSelectedKnowMoreDetailsForMobile?: any;
};

class AppContextProvider extends React.Component<Props, {}> {
  render() {
    return (
      <Context.Provider
        value={{
          omniUrlArgs: this.props.omniUrlArgs,
          trackTemplateEvent: this.props.trackTemplateEvent,
          selectedKnowMoreDetailsForMobile: this.props
            .selectedKnowMoreDetailsForMobile,
          setSelectedKnowMoreDetailsForMobile: this.props
            .setSelectedKnowMoreDetailsForMobile
        }}
      >
        {this.props.children}
      </Context.Provider>
    );
  }
}

export const AppContextConsumer = Context.Consumer;
export default AppContextProvider;
